import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage';

import AuthReducer from "./authReducers";
import DashboardReducer from "./dashboardReducers";
import ProfileReducer from "./profileReducers";
import CompanyReducer from "./companyReducers";
import MainReducer from "./mainReducers";
import MiscellaneousReducer from "./miscellaneousReducers";


const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  auth: AuthReducer,
  dashboard: DashboardReducer,
  profile: ProfileReducer,
  main: MainReducer,
  other: MiscellaneousReducer,
  
  company: CompanyReducer,
});

export default persistReducer(persistConfig, rootReducer);